export const SYSTEM_PRECISION_PHRASE_LENGTH = 5
